/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * イベント記録のレスポンス
 */
export interface TrackEventResponse {
  /** テナントID
フロント側で localStorage の moovy_viewer_session にtenantIdを保存するために返す。
シナリオが見つからない／非公開の場合は undefined。 */
  tenantId?: string
  /** 成功フラグ */
  success: boolean
}
